import { render } from "./buttonField.vue?vue&type=template&id=384cfff5"
import script from "./buttonField.vue?vue&type=script&lang=js"
export * from "./buttonField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__